import * as React from 'react';
export function PageHeaderMedia(_a) {
    var item = _a.item;
    var _b = React.useState(window.innerWidth), windowWidth = _b[0], setWindowWidth = _b[1];
    React.useEffect(function () {
        function handleResize() {
            setWindowWidth(window.innerWidth);
        }
        window.addEventListener('resize', handleResize);
    });
    return (item.videoPath && windowWidth > 800 ? (React.createElement("video", { autoPlay: true, loop: true, muted: true, playsInline: true },
        React.createElement("source", { src: item.videoPath }))) : item.imgPath ? (React.createElement("img", { src: item.imgPath, alt: item.alt, loading: 'eager' })) : null);
}
